module.exports = (socket, factory) => store => {
  Object.keys(factory).forEach(evt => {
    socket.on(evt, msg => {
      const action = factory[evt](msg);
      store.dispatch(action);
    });
  });

  return next => action => {
    return next(action);
  };
};



// WEBPACK FOOTER //
// ../shared/optilit-redux-middleware/socket-analytics-subscribe.js